<template>
  <div class="hpsfir-card category">
    <HpsfirProTable
      ref="tableRef"
      title="分类管理"
      :paginations="{ pageSize: 10 }"
      page-layout="total, sizes, prev, pager, next"
      :columns="columns"
      :get-data="getData"
      :on-add="addFun"
      :on-delete="deleteFun"
      :on-edit="updateFun"
      :loading="loading"
      :is-dangder-delete="true"
      :format-dangder-delete-info="formatDeleteInfo"
      row-key="id"
      :operates="operates"
      :add-init-values="addInitValue"
      :codition-init-values="conditionsInitValue"
    />
  </div>
</template>
<script lang="ts" setup>
import {
  HpsfirProTable,
  HpsfirProTableColumn,
  HpsfirProTableData,
  HpsfirProTableFilter,
  HpsfirProTableGetDataFunction,
  useBaseAsync,
} from 'hpsfir-managebase-ui';
import { useApi } from '@/hooks/useApi';
import { ElMessage } from 'element-plus';
import { ref } from 'vue';

const columns = ref<HpsfirProTableColumn[]>([]);
const tableRef = ref<InstanceType<typeof HpsfirProTable>>();
const gradeOptions = ref<{ label: string; value: number }[]>([]);

const addInitValue = {

};

const conditionsInitValue = {
};

// 创建列定义
const createColumns = () => [
  {
    name: 'name',
    label: '分类名称',
    type: 'string',
    isCondition: true,
    rule: [{ required: true, message: '请输入分类名称' }],
    width: 150,
  },
  {
    name: 'gradeIds',
    label: '关联年级',
    type: 'multiselect',
    rule: [{ required: true, message: '请选择关联年级' }],
    options: gradeOptions,
    width: 200,
  },
  {
    name: 'createTime',
    label: '创建时间',
    type: 'string',
    hideEdit: true,
    hideCreate: true,
    width: 160,
  },
] as HpsfirProTableColumn[];

// 初始化
const init = useBaseAsync(async() => {
  // 获取年级列表
  const gradeRes = await useApi().gradeApi.listGradegrade({
    conditions: {},
  });

  gradeOptions.value = (gradeRes.data.data || []).map((item: any) => ({
    label: item.name,
    value: item.id,
  }));

  columns.value = createColumns();
});

const operates: any[] = [];

const loading = ref(false);

const getData = useBaseAsync<HpsfirProTableGetDataFunction>(async(filter: HpsfirProTableFilter) => {
  try {
    loading.value = true;
    const res = await useApi().categoryApi.pageCategorycategory({
      conditions: Object.entries(filter.conditions).reduce((conditions, [key, val]) => {
        if (val === null || val === undefined || val === '') {
          return conditions;
        }

        conditions[key] = val;

        return conditions;
      }, {} as any),
      pageQuery: {
        page: filter.paginations.page - 1,
        pageSize: filter.paginations.pageSize,
      },
    });

    const tableData: HpsfirProTableData = {
      total: res.data.data?.total || 0,
      data: res.data.data?.data || [],
    };
    return tableData;
  } finally {
    loading.value = false;
  }
});

const formatDeleteInfo = (row: any) => `您确定要删除"${row.name || '未命名'}"分类吗？此操作不可恢复，请谨慎操作。`;

const addFun = useBaseAsync(async(data: any) => {
  await useApi().categoryApi.addCategorycategory({
    categoryAdminVo: {
      ...data,
    },
  });
  ElMessage.success('添加成功');
});

const updateFun = useBaseAsync(async(data: any) => {
  await useApi().categoryApi.updateCategorycategory({
    categoryAdminVo: {
      ...data,
    },
  });
  ElMessage.success('修改成功');
});

const deleteFun = useBaseAsync(async(data: any) => {
  await useApi().categoryApi.delCategorycategory(data.id);
  ElMessage.success('删除成功');
});

Promise.all([init()]);
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
